import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import DOMPurify from 'dompurify';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import CreateVeterinaryModal from '../components/veterinary/CreateVeterinaryModal';
import UpdateVeterinaryModal from '../components/veterinary/UpdateVeterinaryModal';
import * as actions from '../action';
import * as c from '../constant';

function VeterinaryCalculations({
  newOtherFeesId,
  removeVeterinaryFees,
  getNewOtherFeesList,
  getSingleNewOtherFees,
  history,
  veterinaryCalculationList,
  getVeterinaryCalculationList,
  ordinanceRevisionId,
}) {
  const setModal = useContext(ModalContext);

  const handleAddVeterinaryModal = e => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: (
        <CreateVeterinaryModal
          newOtherFeesId={newOtherFeesId}
          veterinaryCalculationList={veterinaryCalculationList}
          ordinanceRevisionId={ordinanceRevisionId}
        />
      ),
      title: 'Add Veterinary Fee',
      modalSize: 'modal-lg',
    });
  };

  const handleEditVeterinaryModal = data => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateVeterinaryModal
          newOtherFeesId={newOtherFeesId}
          ordinanceRevisionId={ordinanceRevisionId}
          updateList={data.attributes}
          id={data.id}
          veterinaryCalculationList={veterinaryCalculationList}
        />
      ),
      title: 'Update Veterinary Fee',
      modalSize: 'modal-lg',
    });
  };

  const handleRemoveVeterinary = data => e => {
    e.preventDefault();

    ConfirmAlert(
      'Are you sure, you want to remove this veterinary fee?',
      () => {
        removeVeterinaryFees(data.id, newOtherFeesId, () => {
          getNewOtherFeesList({ ordinance_revision_id: ordinanceRevisionId });
          history.push(`/bpls/tax-revenue/new-other-fees/${newOtherFeesId}`);
          getSingleNewOtherFees(newOtherFeesId);
          getVeterinaryCalculationList(newOtherFeesId);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const createMarkup = data => {
    return { __html: DOMPurify.sanitize(data || '') };
  };

  return (
    <div>
      <Tabs>
        <TabList>
          <Tab>Veterinary</Tab>
          <div className="ml-auto m-1">
            <button
              type="button"
              className="btn btn-primary cms-bg-color-primary cms-outline-primary     btn-round font-weight-bold px-4 ml-auto"
              onClick={handleAddVeterinaryModal}
            >
              Add Veterinary Calculation
            </button>
          </div>
        </TabList>
        <TabPanel>
          <div className="p-3">
            <table className="transaction-table table table-bordered table-sm table-striped table-hover">
              <thead>
                <tr>
                  <td>Veterinary Registered</td>
                  <td>Detail</td>
                  <td>Amount</td>
                  <td>Action</td>
                </tr>
              </thead>
              <tbody>
                {!_.isEmpty(veterinaryCalculationList) ? (
                  veterinaryCalculationList.map(item => (
                    <tr key={item.id} className="top-border">
                      <td className="text-left">
                        {_.get(item, 'attributes.veterinary_registration')}
                      </td>
                      <td
                        className=""
                        // eslint-disable-next-line
                        dangerouslySetInnerHTML={createMarkup(
                          _.get(item, 'attributes.detail') || '--'
                        )}
                      />
                      <td className="text-left">
                        {_.get(item, 'attributes.amount')}
                      </td>
                      <td className="d-flex text-center">
                        <button
                          type="button"
                          className="btn-blank"
                          onClick={handleEditVeterinaryModal(item)}
                        >
                          <i className="far fa-edit icon-edit" />
                        </button>
                        <button
                          type="button"
                          className="btn-blank"
                          onClick={handleRemoveVeterinary(item)}
                        >
                          <i className="far fa-trash-alt icon-delete" />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr className="text-center">
                    <td colSpan="7">No data</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </TabPanel>
      </Tabs>
    </div>
  );
}

VeterinaryCalculations.propTypes = {
  veterinaryCalculationList: PropTypes.instanceOf(Object).isRequired,
  removeVeterinaryFees: PropTypes.instanceOf(Function).isRequired,
  getNewOtherFeesList: PropTypes.instanceOf(Function).isRequired,
  getSingleNewOtherFees: PropTypes.instanceOf(Function).isRequired,
  getVeterinaryCalculationList: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  newOtherFeesId: PropTypes.string.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }) => ({
  veterinaryCalculationList:
    _.get(api, `${c.GET_VETERINARY_CALCULATION_LIST}.list`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(VeterinaryCalculations);
